import { render, staticRenderFns } from "./CourseShowRecommend.vue?vue&type=template&id=6e15ed9a&scoped=true"
import script from "./CourseShowRecommend.vue?vue&type=script&lang=js"
export * from "./CourseShowRecommend.vue?vue&type=script&lang=js"
import style0 from "./CourseShowRecommend.vue?vue&type=style&index=0&id=6e15ed9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e15ed9a",
  null
  
)

export default component.exports